<span class="categorizer" [class.highlight]="shouldHighlight" (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">{{categorizer}}<span>
